import { LANGUAGE_CODE } from '@/enums';
import i18n from '@/i18n';

export const getLanguageOptions = () =>
  Object.keys(LANGUAGE_CODE)
    .filter((v) => !isNaN(Number(v)))
    .map((key) => {
      return {
        value: key,
        label: i18n.t(`${getCamelCase(LANGUAGE_CODE[Number(key)].toString())}`, { ns: 'common' })
      };
    });
export const getCamelCase = (text: string) => {
  if (!text) {
    return '';
  }
  return text.charAt(0).toLowerCase() + text.slice(1);
};

export const getLanguageOptionsForServiceMessage = () =>
  Object.keys(LANGUAGE_CODE)
    .filter((k) => !isNaN(Number(k)))
    .map((key) => {
      const code = LANGUAGE_CODE[Number(key)];
      let i18nKey = '';
      switch (code) {
        case LANGUAGE_CODE[LANGUAGE_CODE.EnglishUS]:
          i18nKey = 'messageEn';
          break;
        case LANGUAGE_CODE[LANGUAGE_CODE.FrenchFR]:
          i18nKey = 'messageFr';
          break;
        case LANGUAGE_CODE[LANGUAGE_CODE.DutchBE]:
          i18nKey = 'messageNl';
          break;
        case LANGUAGE_CODE[LANGUAGE_CODE.GermanDE]:
          i18nKey = 'messageDe';
          break;
        default:
          i18nKey = 'messageEn';
      }

      return {
        code,
        label: i18n.t(i18nKey, { ns: 'common' })
      };
    });
